export default "__VITE_ASSET__CIBz7Z$p__"